module.exports = __webpack_public_path__ + "img/ic-plus-black.12329357.svg";